import dayjs from 'dayjs';
import Model from '../models/model';
import consts from '../consts';

const model = new Model({
	name: 'Holiday',
	defaultSort: 'Date',
	formTitleField: 'Description',
	title: 'Holiday',
	showGridRefreshBtn: true,
	columns: [
		{ header: 'UniqueId', field: 'HolidayId', keyColumn: true, hidden: true, width: 200 },
		{
			field: 'Date',
			width: 250,
			type: 'date',
			required: true,
			skipTime: true,
			formFormat: consts.MomentFormat.Date
		},
		{ field: 'Description', width: 280, required: true, minLength: 2, maxLength: 400 }
	]
});

export default model.createFormBase();